<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title mb-4">{{'REPORT.REPORT_TITLE' | translate}}</div>
    </div>
    <div class="row">
        <section>
            <app-dynamic-form [formName]="'newIncidentForm'" [formData]="(formData$ | async)!" [disabled]="false"
                (formChange)="onEvent($event)" #dynamicForm></app-dynamic-form>
        </section>
        <app-drag-drop-file (onSelectFile)="handleFileInput($event)" (onRemoveFile)="rmFileInput($event)" (onWaitingLoadFile)="waitingLoadFile = $event"></app-drag-drop-file>
        <div class="d-flex justify-content-center mt-4">
            <button type="submit" class="btn btn-action primary" (click)="submitForm()" [disabled]="!formData?.valid || waitingLoadFile">{{'REPORT.REPORT_SUBMIT' | translate}}</button>
        </div>
    </div>
</div>